import { FC } from "react";
import Link from "next/link";
import Chip from "@mui/material/Chip";

import { useStyles } from "./styles";
import { Nullable } from "@/types/common";

interface TagProps {
  name: string;
  isLora?: boolean;
  rank?: Nullable<number>;
  variant?: "collection" | "dictionary";
  onClick?: () => void;
}

const Tag: FC<TagProps> = ({
  name,
  isLora = false,
  rank,
  variant = "collection",
  onClick = () => {},
}) => {
  const { classes } = useStyles({
    rank,
    isLora,
    interactive: variant !== "collection",
  });

  const getTagLabel = () => {
    let displayLabel = name.toLowerCase();
    if (rank) {
      displayLabel = `${displayLabel} #${rank}`;
    }
    return displayLabel;
  };

  const tagLabel = getTagLabel();

  // Temporarily disable links for collections
  if (variant === "collection")
    return <Chip className={classes.tag} label={tagLabel} />;

  return (
    <Link
      href={`/${variant}/${name}`}
      onClick={onClick}
      className={classes.link}
    >
      <Chip className={classes.tag} label={tagLabel} />
    </Link>
  );
};

export default Tag;
